export const CHECKOUT_URL = "https://autism-en.impultienda.ar/checkout/";

export const MOCKUP_URL =
  "https://cdn.magicpatterns.com/uploads/kfZJ2CrJ9b1EtfEAM7iaDV/MOCKUP_AUTISM-EN.png";

export const AUTHOR_URL =
  "https://cdn.magicpatterns.com/uploads/chwc1tZz3M59WeyaNS2SPN/Dr._Elena_Martins_-_AAC.png";

export const offerVolumes = [
  { label: "Volume 1 — Autism Communication Foundations Blueprint™", value: "$19" },
  { label: "Volume 2 — Functional Communication Assessment Roadmap™", value: "$19" },
  { label: "Volume 3 — Visual Communication Support Blueprint™", value: "$19" },
  { label: "Volume 4 — AAC Planning & Personalization Roadmap™", value: "$19" },
  { label: "Volume 5 — Everyday Communication Implementation Blueprint™", value: "$19" },
  { label: "Volume 6 — Communication Progress & Collaboration Roadmap™", value: "$19" },
];

export const offerBonuses = [
  { label: "Bonus #1 — Everyday Visual Communication Board Library™", value: "$19" },
  { label: "Bonus #2 — Autism Visual Routine Toolkit™", value: "$17" },
  { label: "Bonus #3 — Functional Communication Activity Workbook™", value: "$17" },
  { label: "Bonus #4 — Family & Educator Communication Partner Guide™", value: "$19" },
  { label: "Bonus #5 — Autism Communication Documentation Pack™", value: "$17" },
];

export const offerAccess = [
  "6 Practical Digital Volumes",
  "5 Exclusive Specialized Bonuses",
  "Visual Communication Planning Resources",
  "AAC Organization Frameworks",
  "Functional Observation Worksheets",
  "Family & Educator Collaboration Tools",
  "Everyday Communication Activity Planners",
  "Documentation & Follow-Up Templates",
];

export const buyers = [
  { name: "María Fernanda L.", country: "Mexico" },
  { name: "Valentina R.", country: "Colombia" },
  { name: "Camila P.", country: "Argentina" },
  { name: "Lucía M.", country: "Spain" },
  { name: "Sofía H.", country: "Chile" },
  { name: "Diego R.", country: "Peru" },
  { name: "Andrea C.", country: "Ecuador" },
  { name: "José Luis M.", country: "Guatemala" },
  { name: "Gabriela T.", country: "Uruguay" },
  { name: "Daniela V.", country: "Costa Rica" },
  { name: "Carolina M.", country: "Venezuela" },
  { name: "Paula J.", country: "Dominican Republic" },
  { name: "Ana Belén S.", country: "Paraguay" },
  { name: "Mariana G.", country: "Bolivia" },
  { name: "Isabel F.", country: "Panama" },
];
